// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"226":"38eafa87","263":"7bfd85d7","837":"3148b371","852":"1f39c8f5"}[chunkId] + ".chunk.js";
};